const BACKEND_URL="https://euroavia.gr"
export default BACKEND_URL;
